module.exports = __webpack_public_path__ + "img/wi-fi-pin-red.2ce95ca5.svg";